<template>
  <v-card class="import-unicode-escape">
    <v-card-title class="justify-center">
      {{ $t('unicode_escape.import_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row>
          <v-col cols="4"
                 class="input-label">{{ $t('unicode_escape.import_excel') }}
          </v-col>
          <v-col cols="8">
            <FileInput v-model="excelFile"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       :rules="requiredRules"></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && confirm()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import FileInput from "@/components/FileInput";

export default {
  name: 'ImportAbbreviationDialog',
  components: {FileInput},
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required')
    ]);
    const excelFile = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append('excel', excelFile.value, excelFile.value.name);

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/unicode_escape/import/',
        params: formData,
      });

      if (response.body.success) {
        emit('submit', true)
      }
    }

    return {
      requiredRules,
      excelFile,

      confirm,
    }
  },
}
</script>

<style lang="less">
.import-unicode-escape {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }
}
</style>
